import { render, staticRenderFns } from "./portraitAlert.vue?vue&type=template&id=5b499863&scoped=true"
import script from "./portraitAlert.vue?vue&type=script&lang=js"
export * from "./portraitAlert.vue?vue&type=script&lang=js"
import style0 from "./portraitAlert.vue?vue&type=style&index=0&id=5b499863&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b499863",
  null
  
)

export default component.exports